import initialState from "../InitialState/InitialState";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "ADD_ATHLETE_ACCOUNT_ID":
      return {
        ...state,
        athleteAccountId: action.payload,
      };
    case "ADD_GYM_ACCOUNT_ID":
      return {
        ...state,
        gymAcountId: action.payload,
      };

    case "ADD_CONNECTED_ACCOUNT_ID":
      return {
        ...state,
        connectedAccountId: action.payload,
      };
    case "REMOVE_ATHLETE_ACCOUNT_ID":
      return {
        ...state,
        athleteAccountId: action.payload,
      };
    case "REMOVE_GYM_ACCOUNT_ID":
      return {
        ...state,
        gymAcountId: action.payload,
      };
    case "ADD_GYM_DATA": {
      return {
        ...state,
        gymData: action.payload,
      };
    }
    case "ADD_USER_DATA": {
      return {
        ...state,
        userData: action.payload,
      };
    }
    case "WORKOUT_API_CALLED":
      return {
        ...state,
        workoutApiCalled: ++state.workoutApiCalled,
      };
    case "USER_UPDATED":
      return {
        ...state,
        userUpdated: ++state.userUpdated,
      };
    case "ADD_TRACK_INFO":
      return {
        ...state,
        trackInfo: action.payload,
      };
    case "DATE_CHANGED":
      return {
        ...state,
        dateChanged: action.payload,
      };
    case "TRACK_CHANGED":
      return {
        ...state,
        trackChanged: ++state.trackChanged,
      };
    case "SETTING_API_CALLED":
      return {
        ...state,
        settingsApiCalled: ++state.settingsApiCalled,
      };
    case "SELECTED_ATHLETE":
      return {
        ...state,
        selectedAthlete: action.payload,
      };
    case "UNSELECT_ATHLETE":
      return {
        ...state,
        selectedAthlete: action.payload,
      };
    case "SELECTED_GYM":
      return {
        ...state,
        selectedGym: action.payload,
      };
    case "GYM_LIST":
      return {
        ...state,
        gymList: action.payload,
      };
    case "Is_Duplicate":
      return {
        ...state,
        isDupilicate: action.payload,
      };
    case "NEW_MESSAGE_NOTIFICATION":
      return {
        ...state,
        newMessageNotifications: action.payload,
      };
    case "NEW_NON_MESSAGE_NOTIFICATION":
      return {
        ...state,
        newNonMessageNotifications: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
